class Evaluation360 {
	async allEmployees(companyId, query) {
		const response = await fetch(
			`${process.env.REACT_APP_API}/company/360EmployeeList/${companyId}${query}`,

			{
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
				},
			}
		)

		return response.json()
	}

	/** CRITERIAS */
	async allCriteriaByCompany(companyId) {
		const response = await fetch(`${process.env.REACT_APP_API}/company/360criteria/${companyId}`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
		})

		return response.json()
	}

	async createCriteria(data) {
		const response = await fetch(`${process.env.REACT_APP_API}/company/360criteria`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(data),
		})

		return response.json()
	}

	async updateCriteria(data, criteriaId) {
		const response = await fetch(`${process.env.REACT_APP_API}/company/360criteria/${criteriaId}`, {
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(data),
		})

		return response.json()
	}

	/** TEMPLATES */

	async getAllTemplateByCompany(companyId, query = '') {
		/**
		 * query=(templateName)&page=(numberPage)&limit=(qntElements)
		 */

		const response = await fetch(`${process.env.REACT_APP_API}/company/360template/templates/${companyId}?${query}`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
		})

		return response.json()
	}

	async getOneTemplate(templateId) {
		const response = await fetch(`${process.env.REACT_APP_API}/company/360template/template/${templateId}`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
		})

		return response.json()
	}

	async getAllEmployeeByTemplate(templateId) {
		const response = await fetch(`${process.env.REACT_APP_API}/company/360answers/template/${templateId}`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
		})

		return response.json()
	}

	async createTemplate(data) {
		const response = await fetch(`${process.env.REACT_APP_API}/company/360template/`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(data),
		})

		return response.json()
	}

	async updateTemplate(data, templateId) {
		const response = await fetch(`${process.env.REACT_APP_API}/company/360template/${templateId}`, {
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(data),
		})

		return response.json()
	}

	/** EMPLOYEE */

	async criteriasByEmployee(employeeId) {
		const response = await fetch(`${process.env.REACT_APP_API}/ee/employee/360Criteria/${employeeId}`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
		})

		return response.json()
	}

	/** VERIFICAR SE NA ROTA CRITERIAS ESTA COM MAIUSCULA OU MINUSCULA */
	async createRelationship(data) {
		const response = await fetch(`${process.env.REACT_APP_API}/ee/employee/360Relation/`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(data),
		})

		return response.json()
	}

	async createEvaluation(data) {
		const response = await fetch(`${process.env.REACT_APP_API}/ee/employee/360Evaluation/`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(data),
		})

		return response.json()
	}

	async allRelationship(employeeId) {
		const response = await fetch(`${process.env.REACT_APP_API}/ee/employee/360ListRelation/${employeeId}`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
		})

		return response.json()
	}

	async allAnswers(respondentId) {
		const response = await fetch(`${process.env.REACT_APP_API}/ee/employee/360Answers/${respondentId}`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
		})

		return response.json()
	}

	async updateAnswers(respondentId, data) {
		const response = await fetch(`${process.env.REACT_APP_API}/ee/employee/360Answers/${respondentId}`, {
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(data),
		})

		return response.json()
	}

	async deleteEvaluation(respondentId, data) {
		const response = await fetch(`${process.env.REACT_APP_API}/ee/employee/360Evaluation/${respondentId}`, {
			method: 'DELETE',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(data),
		})

		return response.json()
	}

	async getEmployeesWithTemplates(companyId) {
		const response = await fetch(`${process.env.REACT_APP_API}/ee/employee/360TargetsActiveTemplate/${companyId}`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
		})

		return response.json()
	}
}

export default new Evaluation360()
